export default __webpack_public_path__ + "static/media/LeonardoDeMonke.012ef49e.jpg";